import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Flex, Typography } from "antd";
import { useState } from "react";
import { CampaignEditor } from "../components/CampaignEditor";
import { CampaignList } from "../components/CampaignList";
import { useAuth } from "../hooks/useAuth";
import { Campaign, CampaignDetail } from "../interfaces/Campaign.interface";
import { APIValidationError } from "../utils/api.validation.utils";
import {SearchConfiguration} from "../interfaces/OrgDetail.interface";

export const Push = (props: { applicationId: string, searchConfig: SearchConfiguration | null})=>{
    const [currentCampaign, setCurrentCampaign] = useState<Campaign | null>(null)

    const queryClient = useQueryClient()
    const auth = useAuth();
    // Mutations
    const campaignMutation = useMutation({
        mutationFn: (campaign: Campaign) => auth.api.createCampaign(props.applicationId, campaign),
        onSuccess: async (data:CampaignDetail) => {
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ['campaigns', props.applicationId] })
           console.log("campaign mutation success", data);
        },
        onError: (err:Error)=> {
            console.log("campaign mutation error", err);
            return err;
        }
    })

    const cloneCampaignMutation = useMutation({
        mutationFn: (campaign: Campaign) => auth.api.cloneCampaign(props.applicationId, campaign),
        onSuccess: () => {
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ['campaigns', props.applicationId] })
        },
    })
    const newCampaign = (campaign: Campaign) => {
        setCurrentCampaign(campaign);
    }
    const editCampaign = (campaign: Campaign) => {
        setCurrentCampaign(campaign);
    }
    const onModalDismiss = (campaign: Campaign) => {
        setCurrentCampaign(null);
    }

    const viewCampaign = (campaign: Campaign) => {
        setCurrentCampaign(campaign);
    }

    const onCampaignSave = async (campaign: Campaign): Promise<CampaignDetail|APIValidationError> => {


        let result = await campaignMutation.mutateAsync(campaign ).catch(err=>err);

        return result;
    }

    const onCloneCampaign = async (campaign: Campaign): Promise<boolean> => {
        // Preserve source campaign id and application id
        const sourceId = campaign.id;
        const campaignWithApp: Campaign = { ...campaign, applicationId: campaign.applicationId ?? props.applicationId };

        // Fetch full base64 for preview
        const image = await auth.api.getImageBase64(campaignWithApp).catch(() => null);

        // Derive imageId from hash if missing
        const imageId = campaign.pushMessage.imageId
            ?? (campaign.pushMessage.imageData && !campaign.pushMessage.imageData.startsWith('data:')
                ? campaign.pushMessage.imageData
                : undefined);

        const newCampaign: Campaign & { clonedFromId?: string } = {
            ...campaignWithApp,
            id: undefined,
            deliverAt: "",
            clonedFromId: sourceId
        };

        if (imageId) {
            newCampaign.pushMessage.imageId = imageId;
        }

        if (image && image.length > 0) {
            newCampaign.pushMessage.imageData = image;
        }

        setCurrentCampaign(newCampaign);
        return true;
        // return !!await cloneCampaignMutation.mutateAsync(campaign);
    }
    return (
        <Flex vertical gap={10}>
            <Flex justify="space-between" align="baseline">
                <Typography.Title level={3}>Push</Typography.Title>
                 <CampaignEditor applicationId={props.applicationId} searchConfig={props.searchConfig} campaign={currentCampaign} onEdit={newCampaign} onDismiss={onModalDismiss} onSave={onCampaignSave} />
            </Flex>
            <CampaignList applicationId={props.applicationId} onEdit={editCampaign} onSelect={viewCampaign} onClone={onCloneCampaign} />
        </Flex>
    )
}